import {
    IBillingSystemCompany,
    IBillingSystemCompanyAPI,
    IMeta,
    INameObject,
    INameObjectN,
    IOrdersInvoice,
    IOrdersInvoiceAPI,
    IStringOrNull,
} from './index';
import dayjs from 'dayjs';
import { UnitTypeValues } from '../middleware';

export type IMonthlyOrdersListAPI = {
    monthly_orders?: IMonthlyOrdersListItemAPI[];
    meta?: IMeta;
};

export type IMonthlyOrdersListItemAPI = {
    id: number;
    amount?: string;
    company?: IBillingSystemCompanyAPI;
    created_at?: string;
    due_date?: 'string';
    invoice?: IOrdersInvoiceAPI;
    invoicing_company?: INameObjectN;
    linked_orders_count?: number;
    month?: number;
    period_end?: string;
    period_start?: string;
    purchase_order_number?: IStringOrNull;
    reverse_charge_applies?: boolean;
    status?: string;
    vat_percentage?: string;
    updated_at?: string;
    year?: number;
};

export enum monthlyOrderStatuses {
    APPROVED = 'approved',
    CANCELLED = 'cancelled',
    DRAFT = 'draft',
    PAID = 'paid',
}

export type IMonthlyOrdersListItem = {
    id: number;
    amount?: string;
    companyId?: IBillingSystemCompany;
    createdAt?: string;
    dueDate?: string;
    invoice?: IOrdersInvoice;
    invoicingCompany?: INameObject;
    linkedOrdersCount?: number;
    month?: number;
    periodEnd?: string;
    periodStart?: string;
    purchaseOrderNumber?: string;
    reverseChargeApplies?: boolean;
    status?: monthlyOrderStatuses;
    vatPercentage?: string;
    updatedAt?: string;
    year?: number;
};

export type IMonthlyOrderOrderAPI = {
    id: number;
    amount: string;
    created_at: string;
    description: string;
    purchase_order_number: string;
    status_manual: string;
    updated_at: string;
};

export type IMonthlyOrderOrder = {
    id: number;
    amount: string;
    createdAt?: string;
    description: string;
    purchaseOrderNumber: string;
    statusManual: string;
    updatedAt?: string;
};

export type IUsageProductsItemAPI = {
    unit_type?: string;
    volume?: number;
    cost?: number;
    currency_id?: number;
};

export type IUsageProductsItem = {
    unitType?: UnitTypeValues;
    volume?: number;
    cost?: number;
    currency?: {
        id?: number;
        abbreviation?: string;
    };
};
export interface IGetMonthlyOrderAvailableOrdersAPI {
    available_orders?: Array<IMonthlyOrderOrderAPI>;
}

export type IMonthlyOrderAPI = IMonthlyOrdersListItemAPI & {
    usage_products?: Array<IUsageProductsItemAPI>;
    linked_orders?: Array<IMonthlyOrderOrderAPI>;
};

export type IMonthlyOrder = IMonthlyOrdersListItem & {
    usageProducts?: Array<IUsageProductsItem>;
    linkedOrders?: Array<IMonthlyOrderOrder>;
};

export type IApproveMonthlyOrder = {
    dueDate?: dayjs.Dayjs;
    invoiceDate?: dayjs.Dayjs;
    sendInvoice?: boolean;
    sendInvoiceOnDate?: boolean;
};
export type IApproveMonthlyOrderAPI = {
    due_date?: string;
    invoice_date?: string;
    send_invoice?: boolean;
    send_invoice_on_date?: boolean;
};

export type IMonthlyOrderPostLinkUnlinkAPI = {
    monthly_order: {
        order_id: number;
    };
};

export type IMonthlyOrderPostPoNumber = {
    monthly_order: {
        purchase_order_number: string;
    };
};
